import { render, staticRenderFns } from "./WorkIconStock.vue?vue&type=template&id=c215d412"
import script from "./WorkIconStock.vue?vue&type=script&lang=js"
export * from "./WorkIconStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports